module.exports = __webpack_public_path__ + "static/img/servicesImg1.9e890694.png";